import dayjs from "dayjs";

export const calculateDuration = (updates: any[]) => {
	if (updates.length < 2) return "N/A"; // Not enough updates to calculate duration

	// Sort updates by date to ensure the first and last are correctly identified
	const sortedUpdates = updates.sort(
		(a, b) => new Date(a.Date).getTime() - new Date(b.Date).getTime(),
	);

	// Get the first and last update dates
	const startDate = dayjs(sortedUpdates[0].Date);
	const endDate = dayjs(sortedUpdates[sortedUpdates.length - 1].Date);

	// Calculate the duration
	const days = endDate.diff(startDate, "day");
	const hours = endDate.diff(startDate, "hour") % 24;
	const minutes = endDate.diff(startDate, "minute") % 60;

	// Format the duration as a string
	let formattedDuration = "";
	if (days > 0) formattedDuration += `${days} day${days > 1 ? "s" : ""} `;
	if (hours > 0) formattedDuration += `${hours} hour${hours > 1 ? "s" : ""} `;
	if (minutes > 0)
		formattedDuration += `${minutes} minute${minutes > 1 ? "s" : ""} `;

	return formattedDuration.trim() || "Less than a minute";
};

export const isOverflown = (element: HTMLElement): boolean => {
	if (!element) return false;
	return element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;
};
